// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "bundle." + "a3f739bb21b573bdf245" + ".js";
};